import { render, staticRenderFns } from "./AssignManagerDialog.vue?vue&type=template&id=92245970&"
import script from "./AssignManagerDialog.vue?vue&type=script&lang=js&"
export * from "./AssignManagerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports